<abc-popup
  #supportPopup
  fxLayout="column"
  fxLayoutAlign="center center"
  [width]="'40%'"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'Support'"
  [showCloseButton]="true"
  (onHiding)="onHiding()"
>
  <div
    class="support-popup"
    fxLayout="column"
    fxLayoutGap="15px"
    [style.filter]="showLoaderSupportPopup ? 'blur(0.2rem)' : 'blur(0)'"
  >
    <div class="support-content-container">
      <div class="custom-padding-0">
      
        <div class="custom-margin" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
          <label     class="support-title">{{ dataService.res('Ubt-Support-Mail-Technical-Support') }}</label>
        </div>
      </div>

      <div class="custom-padding-1">
        <label class="label"
          >{{ dataService.res('Ubt-MeasureDetail-Description') }} <span class="color-red">*</span></label
        >
        <abc-text-area
          class="custom-margin"
          labelMode="static"
          [placeholder]="dataService.res('Ubt-Support-Mail-Description')"
          height="150"
          [(value)]="description"
        >
        </abc-text-area>
      </div>

      <div class="custom-padding-1">
        <label class="label">{{ dataService.res('Ubt-Support-Mail-Attachments') }} </label>
        <abc-file-uploader
          #imagesUploader
          class="custom-margin"
          accept="image/*"
          uploadMode="useForm"
          multiple="true"
          (change)="onFileChange($event)"
          [labelText]="dataService.res('Ubt-Support-Mail-Attachments-Text')"
          [uploadFile]="uploadImages"
          (onValueChanged)="onImageUpload($event, uploadImages)"
        >
        </abc-file-uploader>
      </div>
    </div>
    <div [style.marginTop.px]="20">
      <abc-button
        class="send-btn"
        [ngClass]="isSendEnabled() ? 'disabled' : ''"
        [text]="dataService.res('Ubt-Support-Mail-Senden')"
        rtlEnabled="true"
        [disabled]="isSendEnabled()"
        (onClick)="sendSupportTicket()"
      ></abc-button>
    </div>
  </div>
  <de-loader *ngIf="showLoaderSupportPopup"></de-loader>
</abc-popup>
